<p-toast></p-toast>

<div class="my-hr-page-grid">
  <app-page-form-section
    icon="fa-solid fa-user-circle"
    title="Profile"
    subtitle="Your employee record in a clean self-service view.">
    <div class="profile-card">
      <div class="profile-main">
        <h2>{{ workspace?.profile?.profile?.displayName || workspace?.profile?.profile?.firstName || 'Employee profile' }}</h2>
        <div class="profile-number">{{ workspace?.profile?.profile?.employeeNumber || 'No employee number' }}</div>
        <p>{{ workspace?.profile?.profile?.jobName || '-' }} / {{ workspace?.profile?.profile?.departmentName || '-' }}</p>
      </div>
      <div class="profile-details">
        <div><span>Email</span><strong>{{ workspace?.profile?.profile?.emailAddress || '-' }}</strong></div>
        <div><span>Phone</span><strong>{{ workspace?.profile?.profile?.phoneNumber || '-' }}</strong></div>
        <div><span>Status</span><p-tag [value]="label(workspace?.profile?.profile?.status)" [severity]="statusSeverity(workspace?.profile?.profile?.status)"></p-tag></div>
        <div><span>Manager</span><strong>{{ workspace?.profile?.profile?.managerEmployeeName || '-' }}</strong></div>
        <div><span>Work location</span><strong>{{ workspace?.profile?.profile?.workLocation || '-' }}</strong></div>
      </div>
    </div>
  </app-page-form-section>

  <app-page-data-panel
    title="Current preferences"
    subtitle="Existing notification channels already configured for you."
    [resultText]="(workspace?.notificationPreferences?.length || 0) + ' preferences'">
    @if (workspace?.notificationPreferences?.length) {
      <p-table [value]="workspace?.notificationPreferences || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Topic</th>
            <th>Channel</th>
            <th>Address</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td><span class="p-column-title">Topic</span>{{ label(item.topicCode) }}</td>
            <td><span class="p-column-title">Channel</span>{{ label(item.channel) }}</td>
            <td><span class="p-column-title">Address</span>{{ item.deliveryAddress || '-' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="item.enabled ? 'Enabled' : 'Disabled'" [severity]="item.enabled ? 'success' : 'secondary'"></p-tag></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No notification preferences saved yet.</p>
    }
  </app-page-data-panel>
</div>

<app-page-form-section
  icon="fa-solid fa-bell"
  title="Notification preferences"
  subtitle="Choose where updates should be delivered.">
  <div class="form-grid">
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-list"></i></p-inputgroup-addon>
      <p-iftalabel>
        <p-select inputId="topicCode" [options]="topicOptions" optionLabel="label" optionValue="value" [(ngModel)]="notificationForm.topicCode" class="w-full"></p-select>
        <label for="topicCode">Topic</label>
      </p-iftalabel>
    </p-inputgroup>

    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-send"></i></p-inputgroup-addon>
      <p-iftalabel>
        <p-select inputId="channel" [options]="channelOptions" optionLabel="label" optionValue="value" [(ngModel)]="notificationForm.channel" class="w-full"></p-select>
        <label for="channel">Channel</label>
      </p-iftalabel>
    </p-inputgroup>

    <p-inputgroup class="form-span-2">
      <p-inputgroup-addon><i class="pi pi-at"></i></p-inputgroup-addon>
      <p-iftalabel>
        <input pInputText inputId="deliveryAddress" [(ngModel)]="notificationForm.deliveryAddress" placeholder="name@company.com" />
        <label for="deliveryAddress">Delivery address</label>
      </p-iftalabel>
    </p-inputgroup>

    <p-inputgroup class="form-span-2 toggle-group">
      <p-inputgroup-addon><i class="pi pi-check-circle"></i></p-inputgroup-addon>
      <label class="checkbox-row">
        <p-checkbox inputId="preferenceEnabled" binary="true" [(ngModel)]="notificationForm.enabled"></p-checkbox>
        <span>Enable this delivery preference</span>
      </label>
    </p-inputgroup>
  </div>

  <div class="panel-actions-row">
    <button pButton type="button" label="Save preference" icon="pi pi-save" [disabled]="!canManageSelf" [loading]="saving" (click)="savePreference()"></button>
  </div>
</app-page-form-section>
